module.exports = __webpack_public_path__ + "static/img/user.fa9553b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/user.svg
// module id = Xfhb
// module chunks = 1